import React, { useEffect, useRef, useState } from "react";

import "./dragAndDrop.css";
import UploadIcon from "../assets/icons/uploadIcon";

interface DragAndDropProps {
    onUpload: (v: File[]) => void;
    name: string;
}

export default function DragAndDrop(props: DragAndDropProps) {

    const [drag, setDrag] = useState(false);

    const timeout = useRef<NodeJS.Timeout | undefined>(undefined);

    function onDragOver(e: Event) {
        setDrag(true);
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            setDrag(false);
        }, 100);
        e.preventDefault();

    }

    useEffect(() => {
        document.body.addEventListener("dragover", onDragOver);
        return () => {
            document.body.removeEventListener("dragover", onDragOver);
        }
    })

    return <div onDrop={(event) => {
        event.preventDefault();
        var files: File[] = [];
        Array.from(event.dataTransfer.items).forEach((item, i) => {
            if (item.kind === "file") {
              const file = item.getAsFile();
              if(file != null) {
                files.push(file);
              }
            }
          });
        if(files.length > 0) {
            props.onUpload(files);
        }
    }} className={"drag-and-drop" + (drag ? " drag" : "")}>
        <UploadIcon/>
        <p>{props.name}</p>
    </div>;

}